/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_AccountInputs */

const en_pc_cmp_r_account = /** @type {(inputs: Pc_Cmp_R_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

const zh_pc_cmp_r_account = /** @type {(inputs: Pc_Cmp_R_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`账号`)
};

/**
* | output |
* | --- |
* | "Account" |
*
* @param {Pc_Cmp_R_AccountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_account = /** @type {((inputs?: Pc_Cmp_R_AccountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_AccountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_account(inputs)
	return zh_pc_cmp_r_account(inputs)
});
export { pc_cmp_r_account as "pc.cmp.r.account" }